/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { ReactNode } from "react";
import useGoogleTagManager from "../../hooks/useGoogleTagManager";
import useGoogleAnalytics from "../../hooks/useGoogleAnalytics";

type LibInitializerProps = {
  children: ReactNode
};
export default function LibInitializer({ children }: LibInitializerProps) {
  useGoogleTagManager();
  useGoogleAnalytics();

  return <>{children}</>
}
